import * as d3 from "d3";
import D3Utils from "./D3Utils";

class D3Elements {


  // draw a vat width: 120
  static drawVatWithSidewall = (g, x, y) => {

    let currentX = x
    let currentY = y
    const currentWidth = 120
    let h

    // draw the top
    h = 20
    g.append('path')
      .attr('d', `
			      M ${currentX + 2} ${currentY + h}
            L ${currentX + currentWidth - 2} ${currentY + h}
            A ${(currentWidth - 4) / 2 + 5} 20 0 0 0 ${currentX + 2} ${currentY + h}
            `)
      .style("fill", "url(#resourceGradient)")


    // rect 1
    currentY += h + 0.1
    h = 60
    g.append('rect')
      .attr('x', currentX + 2).attr('y', currentY).attr('width', currentWidth - 4).attr('height', h)
      .style("fill", "url(#resourceGradient)")

    // rect 2
    currentY += h + 0.1
    h = 60
    g.append('rect')
      .attr('x', currentX + 2).attr('y', currentY).attr('width', currentWidth - 4).attr('height', h)
      .style("fill", "url(#resourceGradient)")

    // polygon sort: left top / right top /right bottom /left bottom
    currentY += h + 0.1
    h = 3
    g.append("polygon")
      .attr("points", `
                ${currentX + 2} ${currentY} 
                ${currentX + currentWidth - 2} ${currentY} 
                ${currentX + currentWidth} ${currentY + h} 
                ${currentX} ${currentY + h} 
                `)
      .style("fill", "url(#resourceGradient)")


    // rect 3
    currentY += h + 0.1
    h = 60
    g.append('rect')
      .attr('x', currentX).attr('y', currentY).attr('width', currentWidth).attr('height', h)
      .style("fill", "url(#resourceGradient)")

    // three legs
    currentY += h
    h = 6
    g.append('rect').attr('x', currentX + 15).attr('y', currentY).attr('width', 2).attr('height', h)
    g.append('rect').attr('x', currentX + (currentWidth / 2)).attr('y', currentY).attr('width', 2).attr('height', h)
    g.append('rect').attr('x', currentX + currentWidth - 17).attr('y', currentY).attr('width', 2).attr('height', h)

    currentY += h
    h = 2
    g.append('rect').attr('x', currentX + 12).attr('y', currentY).attr('width', 8).attr('height', h)
    g.append('rect').attr('x', currentX + (currentWidth / 2) - 3).attr('y', currentY).attr('width', 8).attr('height', h)
    g.append('rect').attr('x', currentX + currentWidth - 20).attr('y', currentY).attr('width', 8).attr('height', h)


    // draw a agitator
    let offset = 20
    let scaleWidth = 30
    currentX += offset
    currentY -= 20
    h = 6
    g.append("polygon")
      .attr("points", `
                ${currentX + 2 + scaleWidth} ${currentY} 
                ${currentX + currentWidth / 2 - 1} ${currentY + 1} 
                ${currentX + currentWidth / 2 - 1} ${currentY + h - 2} 
                ${currentX + scaleWidth} ${currentY + h} 
                `)
      .attr('stroke', "white")
      .attr('stroke-width', 0.2)
      .style("fill", "url(#resourceGradient)")
    g.append("polygon")
      .attr("points", `
                ${currentX + currentWidth / 2 + 1} ${currentY + 1} 
                ${currentX + currentWidth - scaleWidth} ${currentY} 
                ${currentX + currentWidth - 2 - scaleWidth} ${currentY + h} 
                ${currentX + currentWidth / 2 + 1} ${currentY + h - 2} 
                `)
      .attr('stroke', "white")
      .attr('stroke-width', 0.2)
      .style("fill", "url(#resourceGradient)")

    // draw a stick of the agitator
    currentY = y
    currentX = x + currentWidth / 2
    let cw = 3
    g.append('rect')
      .attr('x', currentX - cw / 2 + offset).attr('y', currentY).attr('width', cw).attr('height', 194)
      .style("fill", "url(#resourceGradient)")

    // draw a motor of the agitator
    cw = 14
    let path = D3Utils.rightRoundedRect(currentX - cw / 2 + offset, currentY, cw, 15, 2, true, true, false, false)
    g.append('path').attr('d', path)
      .style("fill", "url(#resourceGradient)")

    g.append("text")
      .attr("x", x + currentWidth / 2 - 10)
      .attr("y", currentY + 70)
      .attr('class', 'fill-white')
      .text('Milk vat')


    // draw a flash light: vat
    g.append("circle")
      .attr("cx", x + currentWidth / 2)
      .attr("cy", currentY + 100)
      .attr("r", 4)
      .attr('class', 'stroke-white e-sensor-green')

    // // draw a flash light: inlet
    // g.append("circle")
    //   .attr("cx", x - 10)
    //   .attr("cy", 280)
    //   .attr("r", 4)
    //   .attr('class', 'stroke-white e-sensor-green')

    // draw a flash light: agitator
    g.append("circle")
      .attr("cx", currentX + offset)
      .attr("cy", currentY + 14)
      .attr("r", 4)
      .attr('class', 'stroke-white e-sensor-green')

    // // draw a flash light: hot water
    // g.append("circle")
    //   .attr("cx", currentX)
    //   .attr("cy", currentY)
    //   .attr("r", 4)
    //   .attr('class', 'stroke-white e-sensor-green')

    let textBg = D3Utils.rightRoundedRect(currentX + 62, currentY + 25, 70, 56, 2, true, true, true, true)
    g.append('path')
      .attr('d', textBg)
      .style("stroke", "#cccccc")
      .style("fill", "#dddddd")

    let name = g.append("text")
      .attr("x", currentX + 65)
      .attr("y", currentY + 35)
      .attr('class', 'text-data')
      .text('')

    let temp = g.append("text")
      .attr("x", currentX + 65)
      .attr("y", currentY + 45)
      .attr('class', 'text-data')
      .text('')

    let agitator = g.append("text")
      .attr("x", currentX + 65)
      .attr("y", currentY + 55)
      .attr('class', 'text-data')
      .text('')

    let volume = g.append("text")
      .attr("x", currentX + 65)
      .attr("y", currentY + 65)
      .attr('class', 'text-data')
      .text('')

    let vat_size = g.append("text")
      .attr("x", currentX + 65)
      .attr("y", currentY + 75)
      .attr('class', 'text-data')
      .text('')

    return { name: name, temp: temp, agitator: agitator, volume: volume, vat_size: vat_size }

  }

  // draw a vat width: 120
  static drawVat = (g, x, y) => {

    let currentX = x
    let currentY = y
    const currentWidth = 130
    let h

    // draw the top
    h = 20
    g.append('path')
      .attr('d', `
			      M ${currentX} ${currentY + h}
            L ${currentX + currentWidth} ${currentY + h}
            A ${(currentWidth) / 2 + 5} 20 0 0 0 ${currentX} ${currentY + h}
            `)
      .style("fill", "url(#resourceGradient)")

    // rect 1
    currentY += h + 0.1
    h = 70
    g.append('rect')
      .attr('x', currentX).attr('y', currentY).attr('width', currentWidth).attr('height', h)
      .style("fill", "url(#resourceGradient)")


    // rect 3
    currentY += h + 0.1
    h = 70
    g.append('rect')
      .attr('x', currentX).attr('y', currentY).attr('width', currentWidth).attr('height', h)
      .style("fill", "url(#resourceGradient)")

    // three legs
    currentY += h
    h = 6
    g.append('rect').attr('x', currentX + 40).attr('y', currentY).attr('width', 2).attr('height', h)
    g.append('rect').attr('x', currentX + currentWidth - 42).attr('y', currentY).attr('width', 2).attr('height', h)

    currentY += h
    h = 2
    g.append('rect').attr('x', currentX + 37).attr('y', currentY).attr('width', 8).attr('height', h)
    g.append('rect').attr('x', currentX + currentWidth - 45).attr('y', currentY).attr('width', 8).attr('height', h)


    // draw a agitator
    let offset = 20
    let scaleWidth = 30
    currentX += offset
    currentY -= 20
    h = 6
    g.append("polygon")
      .attr("points", `
                ${currentX + 2 + scaleWidth} ${currentY} 
                ${currentX + currentWidth / 2 - 1} ${currentY + 1} 
                ${currentX + currentWidth / 2 - 1} ${currentY + h - 2} 
                ${currentX + scaleWidth} ${currentY + h} 
                `)
      .attr('stroke', "white")
      .attr('stroke-width', 0.2)
      .style("fill", "url(#resourceGradient)")
    g.append("polygon")
      .attr("points", `
                ${currentX + currentWidth / 2 + 1} ${currentY + 1} 
                ${currentX + currentWidth - scaleWidth} ${currentY} 
                ${currentX + currentWidth - 2 - scaleWidth} ${currentY + h} 
                ${currentX + currentWidth / 2 + 1} ${currentY + h - 2} 
                `)
      .attr('stroke', "white")
      .attr('stroke-width', 0.2)
      .style("fill", "url(#resourceGradient)")

    // draw a stick of the agitator
    currentY = y
    currentX = x + currentWidth / 2
    let cw = 3
    g.append('rect')
      .attr('x', currentX - cw / 2 + offset).attr('y', currentY).attr('width', cw).attr('height', 150)
      .style("fill", "url(#resourceGradient)")

    // draw a motor of the agitator
    cw = 14
    let path = D3Utils.rightRoundedRect(currentX - cw / 2 + offset, currentY, cw, 15, 2, true, true, false, false)
    g.append('path').attr('d', path)
      .style("fill", "url(#resourceGradient)")

    g.append("text")
      .attr("x", x + currentWidth / 2 - 10)
      .attr("y", currentY + 70)
      .attr('class', 'fill-white')
      .text('Milk vat')


    // draw a flash light: vat
    g.append("circle")
      .attr("cx", x + currentWidth / 2)
      .attr("cy", currentY + 100)
      .attr("r", 4)
      .attr('class', 'stroke-white e-sensor-green')

    // draw a flash light: agitator
    g.append("circle")
      .attr("cx", currentX + offset)
      .attr("cy", currentY + 14)
      .attr("r", 4)
      .attr('class', 'stroke-white e-sensor-green')

    // vat name draw a rect
    let textBg = D3Utils.rightRoundedRect(currentX + 67, currentY + 25, 70, 56, 2, true, true, true, true)
    g.append('path')
      .attr('d', textBg)
      .style("stroke", "#cccccc")
      .style("fill", "#dddddd")

    let name = g.append("text")
      .attr("x", currentX + 70)
      .attr("y", currentY + 35)
      .attr('class', 'text-data')
      .text('')

    let temp = g.append("text")
      .attr("x", currentX + 70)
      .attr("y", currentY + 45)
      .attr('class', 'text-data')
      .text('')

    let agitator = g.append("text")
      .attr("x", currentX + 70)
      .attr("y", currentY + 55)
      .attr('class', 'text-data')
      .text('')

    let volume = g.append("text")
      .attr("x", currentX + 70)
      .attr("y", currentY + 65)
      .attr('class', 'text-data')
      .text('')

    let vat_size = g.append("text")
      .attr("x", currentX + 70)
      .attr("y", currentY + 75)
      .attr('class', 'text-data')
      .text('')

    return { name: name, temp: temp, agitator: agitator, volume: volume, vat_size: vat_size }

  }

  // draw a plate width: 61.5
  static drawPlate = (g, currentX, currentY) => {
    let h = 90

    g.append('rect')
      .attr('x', currentX).attr('y', currentY + 2).attr('width', 61.5).attr('height', h - 4)
      .attr('class', 'fill-white')

    for (let i = 0; i < 15; i++) {
      let left = currentX + i * 4.1
      let path = D3Utils.rightRoundedRect(left, currentY, 4, h, 2, true, true, true, true)
      g.append('path')
        .attr('d', path)
        .attr('class', 'highlight')
    }

    g.append('rect')
      .attr('x', currentX + 21).attr('y', currentY + 39).attr('width', 20).attr('height', 10)
      .attr('class', 'highlight')

    g.append("text")
      .attr("x", currentX + 23)
      .attr("y", currentY + 45)
      .attr('class', 'fill-white')
      .text('Plate')

    // // draw a flash light: milk inlet
    // g.append("circle")
    //   .attr("cx", currentX - 12)
    //   .attr("cy", 280)
    //   .attr("r", 4)
    //   .attr('class', 'stroke-white e-sensor-green')

    // // draw a flash light: water inlet
    // g.append("circle")
    //   .attr("cx", currentX - 12)
    //   .attr("cy", currentY + 10)
    //   .attr("r", 4)
    //   .attr('class', 'stroke-white e-sensor-green')

    // // draw a flash light: water output
    // g.append("circle")
    //   .attr("cx", currentX - 12)
    //   .attr("cy", currentY + 20)
    //   .attr("r", 4)
    //   .attr('class', 'stroke-white e-sensor-green')

    // // draw a flash light: water inlet
    // g.append("circle")
    //   .attr("cx", currentX + 73)
    //   .attr("cy", currentY + 10)
    //   .attr("r", 4)
    //   .attr('class', 'stroke-white e-sensor-green')

    // // draw a flash light: water output
    // g.append("circle")
    //   .attr("cx", currentX + 73)
    //   .attr("cy", currentY + 20)
    //   .attr("r", 4)
    //   .attr('class', 'stroke-white e-sensor-green')

  }

  // draw a Refrigeration Units width: 100
  static drawRefrigeration = (g, currentX, currentY) => {

    // polygon
    let w = 70, h = 40
    g.append("polygon")
      .attr("points", `
                ${currentX} ${currentY} 
                ${currentX + w} ${currentY} 
                ${currentX + w} ${currentY + h} 
                ${currentX} ${currentY + h} 
                `)
      .on("mouseover", function () {
        d3.select(this).call((node) => {
          node.attr("class", "cursor-pointer highlight").style("fill", null)
        })
      })
      .on("mouseout", function () {
        d3.select(this).call((node) => {
          node.style("fill", "url(#resourceGradientRotate)")
        })
      })
      .style("fill", "url(#resourceGradientRotate)")

    // fan
    let path = 'M 15 3 C 8.382812 3 3 8.382812 3 15 C 3 21.617188 8.382812 27 15 27 C 21.617188 27 27 21.617188 27 15 C 27 8.382812 21.617188 3 15 3 Z M 15 5 C 20.535156 5 25 9.464844 25 15 C 25 20.535156 20.535156 25 15 25 C 9.464844 25 5 20.535156 5 15 C 5 9.464844 9.464844 5 15 5 Z M 17 7 C 16.921875 7 16.839844 7.007812 16.761719 7.015625 C 15.3125 7.171875 14.261719 8.789062 14.046875 13.246094 C 13.445312 13.570312 13.050781 14.1875 13.003906 14.871094 C 11.871094 15.285156 11.136719 15.042969 9.441406 14.371094 L 9.4375 14.375 C 9.234375 14.304688 9.019531 14.269531 8.804688 14.265625 C 7.699219 14.265625 6.804688 15.164062 6.804688 16.265625 C 6.804688 16.617188 6.898438 16.960938 7.074219 17.265625 L 7.070312 17.265625 C 7.078125 17.277344 7.085938 17.285156 7.089844 17.292969 C 7.132812 17.367188 7.183594 17.441406 7.238281 17.511719 C 7.277344 17.5625 7.320312 17.609375 7.363281 17.65625 C 7.367188 17.660156 7.367188 17.660156 7.371094 17.664062 C 8.296875 18.648438 10.226562 18.625 13.953125 16.703125 C 14.269531 16.898438 14.632812 17 15 17 C 15.308594 17 15.609375 16.929688 15.886719 16.792969 C 16.792969 17.550781 16.964844 18.308594 17.21875 20.035156 C 17.226562 20.0625 17.230469 20.085938 17.234375 20.109375 C 17.234375 20.117188 17.234375 20.121094 17.234375 20.125 C 17.425781 21.058594 18.242188 21.730469 19.195312 21.734375 C 19.910156 21.730469 20.570312 21.351562 20.925781 20.734375 L 20.929688 20.734375 C 20.933594 20.722656 20.9375 20.710938 20.941406 20.703125 C 20.980469 20.632812 21.015625 20.5625 21.046875 20.488281 C 21.070312 20.4375 21.085938 20.382812 21.105469 20.328125 C 21.105469 20.328125 21.105469 20.324219 21.109375 20.324219 C 21.109375 20.320312 21.109375 20.316406 21.109375 20.3125 C 21.53125 19.011719 20.5625 17.34375 17 15.050781 C 17 15.035156 17 15.019531 17 15 C 17 14.332031 16.664062 13.707031 16.109375 13.339844 C 16.3125 12.171875 16.882812 11.648438 18.246094 10.566406 C 18.25 10.558594 18.257812 10.554688 18.265625 10.546875 C 18.289062 10.527344 18.300781 10.519531 18.324219 10.5 C 18.753906 10.117188 19 9.574219 19 9 C 19 7.894531 18.105469 7 17 7 Z M 17 7'
    let gg = g.append('g').attr('transform', `matrix(0.8, 0, 0, 0.8, ${currentX + 10}, ${currentY + 12})`)
    gg.append('path').attr('d', path).attr('class', 'rotate fill-white')
    gg = g.append('g').attr('transform', `matrix(0.8, 0, 0, 0.8, ${currentX + 34}, ${currentY + 12})`)
    gg.append('path').attr('d', path).attr('class', 'rotate fill-white')

    g.append("text")
      .attr("x", currentX + w / 2 - 18)
      .attr("y", currentY + 8)
      .attr('class', 'fill-white')
      .text('Refrigeration')

  }

  // draw a ice bank width: 100
  static drawIce = (g, currentX, currentY) => {
    // polygon
    let w = 60, h = 40
    g.append('rect')
      .attr('x', currentX).attr('y', currentY).attr('width', w).attr('height', h)
      .style("fill", "url(#resourceGradientRotate)")

    g.append("polygon")
      .attr("points", `
                ${currentX} ${currentY + 5} 
                ${currentX} ${currentY + h} 
                ${currentX - 40} ${currentY + h} 
                ${currentX - 40} ${currentY + 20} 
                ${currentX - 10} ${currentY + 5} 
                `)


    // fan
    let path = 'M 15 3 C 8.382812 3 3 8.382812 3 15 C 3 21.617188 8.382812 27 15 27 C 21.617188 27 27 21.617188 27 15 C 27 8.382812 21.617188 3 15 3 Z M 15 5 C 20.535156 5 25 9.464844 25 15 C 25 20.535156 20.535156 25 15 25 C 9.464844 25 5 20.535156 5 15 C 5 9.464844 9.464844 5 15 5 Z M 17 7 C 16.921875 7 16.839844 7.007812 16.761719 7.015625 C 15.3125 7.171875 14.261719 8.789062 14.046875 13.246094 C 13.445312 13.570312 13.050781 14.1875 13.003906 14.871094 C 11.871094 15.285156 11.136719 15.042969 9.441406 14.371094 L 9.4375 14.375 C 9.234375 14.304688 9.019531 14.269531 8.804688 14.265625 C 7.699219 14.265625 6.804688 15.164062 6.804688 16.265625 C 6.804688 16.617188 6.898438 16.960938 7.074219 17.265625 L 7.070312 17.265625 C 7.078125 17.277344 7.085938 17.285156 7.089844 17.292969 C 7.132812 17.367188 7.183594 17.441406 7.238281 17.511719 C 7.277344 17.5625 7.320312 17.609375 7.363281 17.65625 C 7.367188 17.660156 7.367188 17.660156 7.371094 17.664062 C 8.296875 18.648438 10.226562 18.625 13.953125 16.703125 C 14.269531 16.898438 14.632812 17 15 17 C 15.308594 17 15.609375 16.929688 15.886719 16.792969 C 16.792969 17.550781 16.964844 18.308594 17.21875 20.035156 C 17.226562 20.0625 17.230469 20.085938 17.234375 20.109375 C 17.234375 20.117188 17.234375 20.121094 17.234375 20.125 C 17.425781 21.058594 18.242188 21.730469 19.195312 21.734375 C 19.910156 21.730469 20.570312 21.351562 20.925781 20.734375 L 20.929688 20.734375 C 20.933594 20.722656 20.9375 20.710938 20.941406 20.703125 C 20.980469 20.632812 21.015625 20.5625 21.046875 20.488281 C 21.070312 20.4375 21.085938 20.382812 21.105469 20.328125 C 21.105469 20.328125 21.105469 20.324219 21.109375 20.324219 C 21.109375 20.320312 21.109375 20.316406 21.109375 20.3125 C 21.53125 19.011719 20.5625 17.34375 17 15.050781 C 17 15.035156 17 15.019531 17 15 C 17 14.332031 16.664062 13.707031 16.109375 13.339844 C 16.3125 12.171875 16.882812 11.648438 18.246094 10.566406 C 18.25 10.558594 18.257812 10.554688 18.265625 10.546875 C 18.289062 10.527344 18.300781 10.519531 18.324219 10.5 C 18.753906 10.117188 19 9.574219 19 9 C 19 7.894531 18.105469 7 17 7 Z M 17 7'
    let gg = g.append('g').attr('transform', `matrix(0.6, 0, 0, 0.6, ${currentX - 38}, ${currentY + 22})`)
    gg.append('path').attr('d', path).attr('class', 'rotate fill-white')
    gg = gg.append('g').attr('transform', `matrix(1, 0, 0, 1, 31, 0)`)
    gg.append('path').attr('d', path).attr('class', 'rotate fill-white')


    g.append("text")
      .attr("x", currentX + w / 2 - 12)
      .attr("y", currentY + h / 2)
      .attr('class', 'fill-white')
      .text('Ice bank')

    g.append("line")
      .attr("x1", currentX)
      .attr("y1", currentY + 22)
      .attr("x2", currentX - 40)
      .attr("y2", currentY + 22)
      .attr('class', 'stroke-light')
  }

  // draw a chilling width: 100
  static drawChilling = (g, currentX, currentY) => {

    // polygon
    let w = 50, h = 50
    g.append('rect').attr('x', currentX).attr('y', currentY).attr('width', w).attr('height', h)

    let top_h = 3
    let top_w = 15
    let top_gap = (w - top_w * 2) / 3
    g.append('rect')
      .attr('x', currentX + top_gap).attr('y', currentY - top_h).attr('width', top_w).attr('height', top_h)

    g.append('rect')
      .attr('x', currentX + top_gap * 2 + top_w).attr('y', currentY - top_h).attr('width', top_w).attr('height', top_h)

    let n = currentX
    while (true) {
      n += 5
      g.append("line")
        .attr("x1", n)
        .attr("y1", currentY + 5)
        .attr("x2", n)
        .attr("y2", currentY + 30)
        .attr('class', 'stroke-light')
      if (n >= currentX + w - 5) {
        break
      }
    }

    n = currentY
    while (true) {
      n += 5
      g.append("line")
        .attr("x1", currentX + 5)
        .attr("y1", n)
        .attr("x2", currentX + w - 5)
        .attr("y2", n)
        .attr('class', 'stroke-light')
      if (n >= currentY + 30) {
        break
      }
    }

    // water or glycol
    let x = currentX + 55
    let y = currentY
    g.append('rect')
      .attr('x', x).attr('y', y).attr('width', w).attr('height', h)
      .style("fill", "url(#resourceGradient)")


    // draw the top
    h = 20
    g.append('path')
      .attr('d', `
			      M ${x} ${y}
            L ${x + w} ${y}
            A 80 100 0 0 0 ${x} ${y}
            `)

    g.append("text")
      .attr("x", currentX + w / 2 - 10)
      .attr("y", currentY + 42)
      .attr('class', 'fill-white')
      .text('Chilling')

    g.append("text")
      .attr("x", x + 3)
      .attr("y", currentY + 30)
      .attr('class', 'fill-white')
      .text('Water or Glycol')

  }

}

export default D3Elements
